import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../api/instances/axiosInstance";
import {
  GET_EMSL_PROJECT_DETAILS,
  GET_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE,
  GET_EMSL_SUMMARY_CONSENTED_HCP_DETAILS,
  GET_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS,
  GET_EMSL_SUMMARY_COUNT,
  GET_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE,
  GET_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS,
  GET_EMSL_SUMMARY_ENGAGED_USER_LIST,
  GET_EMSL_SUMMARY_IN_DEMO_CALENDER,
  GET_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY,
  GET_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS,
  GET_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO,
  GET_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS,
  GET_EMSL_SUMMARY_LEADS_USER_DETAILS,
  GET_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT,
  GET_EMSL_SUMMARY_PRESCRIBER_LBL_SENT,
  GET_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE,
  GET_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT,
  GET_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE,
  GET_LEAD_DATA_FILE,
  GET_TEMPLATE_FETCH,
} from "../../../api/endpoints/emsl-endpoints";
import {
  KEY_EMSL_PROJECT_DETAILS,
  KEY_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE,
  KEY_EMSL_SUMMARY_CONSENTED_HCP_DETAILS,
  KEY_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS,
  KEY_EMSL_SUMMARY_COUNT,
  KEY_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE,
  KEY_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS,
  KEY_EMSL_SUMMARY_ENGAGED_USER_LIST,
  KEY_EMSL_SUMMARY_IN_DEMO_CALENDER,
  KEY_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY,
  KEY_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS,
  KEY_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO,
  KEY_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS,
  KEY_EMSL_SUMMARY_LEADS_USER_DETAILS,
  KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT,
  KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT_By_ID,
  KEY_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE,
  KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT,
  KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_SENT,
  KEY_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE,
  KEY_LEAD_DATA_FILE,
  KEY_TEMPLATE_FETCH,
} from "../../query-constants/workspace/emsl-constant";

const staleTime = 300000;
const cacheTime = 600000;

export const useGetSummaryCount = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_COUNT, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_COUNT}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryEngagedBrandExposure = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryEngagedUniqueUsers = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryEngagedUserList = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_ENGAGED_USER_LIST, project_id, payload],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_ENGAGED_USER_LIST}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date &&
        !!payload?.end_date &&
        !!payload?.content_id &&
        !!payload?.limit,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryConsentedBrandExposure = (
  project_id,
  payload = {}
) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryConsentedUniqueUsers = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryConsentedHcpDetails = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_CONSENTED_HCP_DETAILS, project_id, payload],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_CONSENTED_HCP_DETAILS}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryInDemoSchedumeStatus = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryInDemoMediumDemo = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryInDemoGeography = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryInDemoCalendar = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_IN_DEMO_CALENDER, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_IN_DEMO_CALENDER}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryInDemoHcpDetails = (project_id, payload = {}) => {
  return useQuery(
    [
      KEY_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS,
      project_id,
      payload?.masked_data,
      payload?.offset,
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date &&
        !!payload?.end_date &&
        !!payload?.content_id &&
        !!payload?.limit,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryPrescribersNpsScore = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryPrescribersLblSent = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_SENT, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_PRESCRIBER_LBL_SENT}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryPrescribersHcpScore = (project_id, payload = {}) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryPrescribersLblDocument = (
  project_id,
  payload = {}
) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT, project_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};

export const useGetSummaryLeadsUserDetails = (
  project_id,
  user_id,
  payload = {}
) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_LEADS_USER_DETAILS, project_id, user_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_LEADS_USER_DETAILS}/${user_id}/detail-data`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryLeadsUserEngagement = (
  project_id,
  user_id,
  payload = {}
) => {
  return useQuery(
    [KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT, project_id, user_id],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT}/${user_id}/engagement-data`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date && !!payload?.end_date && !!payload?.content_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetSummaryLeadsUserEngagementById = (
  project_id,
  user_id,
  engagement_id,
  payload = {}
) => {
  return useQuery(
    [
      KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT_By_ID,
      project_id,
      user_id,
      engagement_id,
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${GET_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT}/${user_id}/engagement-data/${engagement_id}`,
        payload
      ),
    {
      enabled:
        !!payload?.start_date &&
        !!payload?.end_date &&
        !!payload?.content_id &&
        !!engagement_id,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetProjectDetails = (project_id, enabled) => {
  return useQuery(
    [KEY_EMSL_PROJECT_DETAILS, project_id],
    () =>
      axiosInstance.post(`project/${project_id}/${GET_EMSL_PROJECT_DETAILS}`, {
        project_id: project_id,
      }),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetLeadDataFile = (project_id, enabled, leadId) => {
  return useQuery(
    [KEY_LEAD_DATA_FILE, project_id, leadId],
    () =>
      axiosInstance.post(`project/${project_id}/${GET_LEAD_DATA_FILE}`, {
        lead_id: leadId,
      }),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
export const useGetTemplateFetch = (type, enabled) => {
  return useQuery(
    [KEY_TEMPLATE_FETCH, type],
    () =>
      axiosInstance.post(`project/${GET_TEMPLATE_FETCH}`, {
        type: type,
      }),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? {},
    }
  );
};
